module.exports = __webpack_public_path__ + "static/img/04.a925697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/04.jpg
// module id = PBkQ
// module chunks = 0